import React from 'react'
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonCard, IonCardContent ,IonCardTitle, IonCardHeader, IonCardSubtitle, IonButton, IonIcon } from '@ionic/react'
import { logoWhatsapp } from 'ionicons/icons'

import ModalImage from 'react-modal-image'

import './About.css'


const About = () => {
    return(
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>
                        About
                    </IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonCard style={{display:'block'}}>
                    <IonCardContent>
                        <IonCard className="card" >
                            <IonCardHeader style={{textAlign:'center'}}>
                                <IonCardTitle className="title">Victor Balmiki</IonCardTitle>
                                <IonCardSubtitle className="title"> <b>Coach Of Speed Skating</b> </IonCardSubtitle>
                                <IonCardSubtitle className="title"><b>State :- West Bengal</b> </IonCardSubtitle>
                                <IonCardSubtitle className="title"><b>City :- Kolkata</b> </IonCardSubtitle>
                                <ModalImage small={require('./Assets/coach2.jpg')} large={require('./Assets/coach2.jpg')} />
                            </IonCardHeader>
                            <IonCardContent /*style={{color:'blue'}}*/ >
                                Victor is a former member of the Bengal skating team and first participated in the state championship in
                                2008 . He continued to participate in the championships organized by the Roller Skating Association of
                                West Bengal (RSAWB) till 2014 . He won numerous medals in the championships . His personal favourite
                                was the 500m speed event where he always bagged the gold .
                                Victor represented Bengal in the 2008-09 , 2010-11 and 2014-15 national championships held at
                                Faridabad , Vishakhapatnam and Mumbai respectively . He turned a full time coach after retiring from
                                competitive skating.
                            </IonCardContent>
                        </IonCard>
                        <a style={{ color: 'white', textDecoration: 'none' }} href="https://api.whatsapp.com/send?phone=919804221906">

                            <IonButton mode="ios" shape="round" color="success" expand="full">
                                <IonIcon icon={logoWhatsapp} mode="ios" /> &nbsp;&nbsp;
                                Chat On Whatsapp
                        </IonButton>
                        </a>

                    </IonCardContent>
                </IonCard>
            </IonContent>
        </IonPage>
    )
}

export default About

// href="https://api.whatsapp.com/send?phone=919804221906"
// href='https://api.whatsapp.com/send?phone=919804221906&text=${whatsappMsg}'
// https://www.google.com/maps/dir//Bidhan+Sishu+Udyan,+Bidhan+Sishu+Sarani,+Ghose+Bagan,+Kolkata,+West+Bengal+700054/@22.5863593,88.3247426,12z/data=!3m1!4b1!4m8!4m7!1m0!1m5!1m1!1s0x3a0276731884aff1:0x74423f55fd62857a!2m2!1d88.394783!2d22.5863745
